import { Component, OnInit , AfterViewInit, Input , Output, EventEmitter} from '@angular/core';
import {ApiService} from "../api.service";

declare var jquery:any;
declare var $ :any;
declare var Swiper :any;
declare var wx: any;

@Component({
  selector: 'app-course-learning-home-page',
  templateUrl: './course-learning-home-page.component.html',
  styleUrls: ['./course-learning-home-page.component.css','../../assets/css/swiper-3.4.2.min.css']
})
export class CourseLearningHomePageComponent implements OnInit , AfterViewInit {
    @Input() course:any;
    @Output() onLessonChosen = new EventEmitter<number>();
    @Output() onExit = new EventEmitter<any>();

    courseNumber: number;
    finishedNumber: number;
    firstUnfinished:number;

    constructor(private  apiService: ApiService) { }

  ngOnInit() {
      this.courseNumber=this.course.lessons.length;
      this.setFinishedNumber();
}

    ngAfterViewInit() {
        let html = document.documentElement;
        let htmlFontSize;
        /*if(html.clientWidth<window.screen.height){
            htmlFontSize = html.clientWidth / 7.5;
        }else{
            htmlFontSize = window.screen.height/ 7.5;
        }*/
        if(window.screen.width<window.screen.height){
            htmlFontSize = window.screen.width/ 7.5;
        }else{
            htmlFontSize = window.screen.height/ 7.5;
        }

        html.style.fontSize=htmlFontSize+"px";
        html.style.backgroundColor="#fff";



        let lessons = this.course.lessons;
        let lessonsLength = lessons.length;
        let firstFinded = false;
        for(let i=0;i<lessonsLength;i++){
            $(".card").eq(i).find(".cardPic").css("backgroundImage","url("+lessons[i].picture+")");
            if(lessons[i].status == 2){
                $(".card").eq(i).find(".lessonStatus").css("background","#7ccfc8");
                $(".card").eq(i).find(".lessonStatus").text("已完成");
            }else if(lessons[i].status < 2 && !firstFinded){
                firstFinded = !firstFinded;
                this.firstUnfinished = i;
            }
        }


        let cardWidth=htmlFontSize*5.2;
        let spaceWidth=htmlFontSize*0.36;
        let swiper = new Swiper('#cards_wrap', {
            width:cardWidth,
            spaceBetween : spaceWidth,
            onTransitionEnd: function (swiper) {
                $("#head_wrap_picture").css("backgroundImage","url("+lessons[swiper.activeIndex].picture+")");
            }
        });

        $("#head_wrap_picture").css("backgroundImage","url("+lessons[swiper.activeIndex].picture+")");

        swiper.slideTo(this.firstUnfinished, 1000, true);
    }

    setFinishedNumber() {
        this.finishedNumber = 0;
        for (let i = 0; i < this.course.lessons.length; i++) {
            if (this.course.lessons[i].status == 2) {
                this.finishedNumber++;
            }
        }

        if (this.finishedNumber > 0) {
          const obj = document.getElementById('axisWrap' + this.finishedNumber);
          if (obj) {
            $(window).scrollTop(obj.offsetHeight);
          }
        }
    }

    getLesson(i){
        if(i <= this.finishedNumber){
            this.onLessonChosen.emit(i);
        }
    }

    close() {
        if(this.finishedNumber < this.courseNumber){
            $("#shade").fadeIn(300);
            $("#tip1").fadeIn(300);
            this.disableRolling();
        }else{
            this.exit();
        }
    }

    continue() {
        $("#tip1").fadeOut(300);
        $("#shade").fadeOut(300);
    }

    exit() {
        this.onExit.emit(true);
    }

    disableRolling(){
        document.getElementById('shade').ontouchstart = function(e){ e.preventDefault(); }
    }
}



// WEBPACK FOOTER //
// ./src/app/course-learning-home-page/course-learning-home-page.component.ts